import {BasicObject} from '@/types';
import {View, StyleSheet} from 'react-native';
import Text from '@/components/basic/text';
import React from 'react';
import theme from '@/style';
import {useTranslation} from 'react-i18next';
import Ball from '@/common-pages/color/components/ball';

const ColorResult = ({info = {}}: {info: BasicObject}) => {
  const {i18n} = useTranslation();
  const ballRender = React.useMemo(() => {
    if (info.colorResult) {
      const bg = info.colorResult;
      return (
        <Ball
          onlyColor={false}
          digit={info.digitResult}
          color={bg}
          ballSize={32}
          fontSize={16}
        />
      );
    }
    return null;
  }, [info]);

  return (
    <View style={[theme.flex.row, theme.padding.tbl, styles.container]}>
      <View style={[theme.flex.flex1]}>
        <Text size="medium" fontFamily="fontInterBold">
          {info.groupOrderNo}
        </Text>
        <Text size="medium" fontFamily="fontInterBold">
          {i18n.t('bets-detail.label.drawRes')}:
        </Text>
      </View>
      <View style={[theme.flex.flex1, styles.result]}>{ballRender}</View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    paddingHorizontal: 20,
    ...theme.background.white,
    marginBottom: 12,
  },
  result: {
    paddingHorizontal: 12,
    paddingVertical: 4,
    backgroundColor: theme.backgroundColor.blueGrey,
    borderRadius: 8,
    justifyContent: 'center',
    alignItems: 'center',
  },
});

export default ColorResult;
